













import {
  Component, Vue, Prop,
} from 'vue-property-decorator';
import PermissionTreeItem from './PermissionTreeItem.vue';

@Component({
  components: {
    PermissionTreeItem,
  },
})
export default class PermissionTree extends Vue {
  @Prop(Array) readonly items!: PermissionItem[];
  @Prop(Boolean) readonly disabled!: boolean;

  updateValue() {
    this.$emit('on-change', this.items);
  }
}
